export default "__VITE_ASSET__DoBjOpbO__"